import { render } from "./TransactionDeletedView.vue?vue&type=template&id=7432ecf4"
import script from "./TransactionDeletedView.vue?vue&type=script&lang=js"
export * from "./TransactionDeletedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__